import PatcraftApi from "../../../scripts/patcraft-api";
import commonMethods from "../../../scripts/common-methods";
import Cropper from 'cropperjs'; // Import the Cropper.js library
import {coverImageCroppingsTransformer} from "../../../helpers"


const state = () => ({
  projectUsers :[],
  selectAnotherImage:false,
  isAdminMode:false,
  getCompareData:{},
  getCompareDataDownloadTray:[],
  IsstartOverOrCancel:false,
  saveTrayForShare:'',
  trayAlreadyExist : '',
  archiveResourceString:'',
  resourceString:'',
  boards: [],
  filter: {},
  boardDetails:{},
  orderHistory:[],
  selectedSortByOption: "UpdatedAt",
  selectedTabName: "Active",
  selectedSideNav: window.location.href.toLowerCase().includes("myprojects") ? "MyProjects" : "MyTrays",
  isModalVisible: false,
  searchtext: "",
  getTrayUserApiResponse: [],
  createShareTray: [],
  shareTrayId: "",
  redirectToMyTray:false,
  refreshToken: "",
  loader: false,
  orderHisLoader:false,
  virtualTrayParam: {
    isAdmin: true,
    culture: "en-us",
    pageNumber: 1,
    pageSize: 9,
    sortBy: "UpdatedAt",
    sortByAsc: false,
    type: "Active",
    searchTerm: "",
    brandBoardType :"",
    siteProjectName: window.location.href.toLowerCase().includes("myprojects") ? "ProjectFeature" : "VirtualTray",


  },
  oderHistoryParam: {
    pageNumber: 1,
    pageSize: 15,
  },
  selectedTrayId: [],
  totalPage: 0,
  orderHistTotalPage:0,
  userInfoEmailId:'',
  orderBy:'desc',
  orderHistoryTotalPage:0,
  orderHistorypageSize:20,
  archiveMsgString:'',
  fileName:null,
  fileUrl:'',
  imageData:{
    thumbnail: null,
  },
  imageCropData:{
    thumbnail: null,
  },
  trayState:{
    coverPhoto:'',
    coverImage:''
  },
  uploadImageData:{},
  imageCropped:null,
  coverImageCroppings:[],
  blobURL:'',
  trayEditDetails:{},
  trayEditId:null,
  selectedTray:'',
  updatedProjectUser:[],
  deletedProjectUsers:[],
  errorMsg : ""
});

// Getters
const getters = {
  getAllVirtualTrayBoardData: state => {
    return state.boards;
  },
  getselectedSortByOption: state => {
    return state.selectedSortByOption;
  },
  getselectedTabName: state => {
    return state.selectedTabName;
  },
  getselectedSideNav:state=>{
    return state.selectedSideNav
  },
  getShowModal: state => {
    return state.isModalVisible;
  },
  getSearchInput: state => {
    return state.searchtext;
  },
  TrayUserIdApiResponse: state => {
    return state.getTrayUserApiResponse;
  },
  getCreateShareTray: state => {
    return state.createShareTray;
  },
  getShareTrayId: state => {
    return state.shareTrayId;
  },
  getRefreshToken: state => {
    return state.refreshToken;
  },
  getLoader: state => {
    return state.loader;
  },
  getOrderHisLoader: state => {
    return state.orderHisLoader;
  },

  getSelectedTrayId: state => {
    return state.selectedTrayId;
  },
  showLoadMore: state => {
    return (
      state.totalPage > state.virtualTrayParam.pageNumber ||
      (state.loader && state.boards.length === 0)
    );
  },
  showOrderHistoryLoadMore: state => {
    return (
      state.orderHistoryTotalPage > state.oderHistoryParam.pageNumber ||
      (state.orderHisLoader && state.orderHistory.length === 0)
    );
  },
  getUserInfoEmail:state=> {
    return state.filter.userEmail;
  },
  getUserEmaiFromVTpage:state=>{
    return state.userInfoEmailId
  },
  getEditTrayDetails:state=>{
    return state.boardDetails ;
  },
  getFileUrl:state=>{
    return state.fileUrl;
  },
  getFileName:state=>{
    return state.fileName;
  },
  getImageData:state=>{
    return state.imageData
  },
  getUploadImageResp:state=>{
return state.uploadImageData
  },
  getCoverImageCroppings:state=>{
    return state.coverImageCroppings
  },
  getblobURL:state=>{
    return state.blobURL
  },
  gettrayEditDetails:state=>{
    return state.trayEditDetails
  },
  getRedirectToMyTray:state=>{
    return state.redirectToMyTray
  },
  gettrayEditId:state=>{
    return state.trayEditId
  },
  getVirtualTrayParamSortBy:state=>{
    return state.virtualTrayParam.sortBy
  },
  getIsstartOverOrCancel:state=>{
    return state.IsstartOverOrCancel
  },
  getselectAnotherImage:state=>{
    return state.selectAnotherImage
  },
  getComparedProductData:state=>{
    return state.getCompareData
  },
  getComparedProductDataDownloadTray:state=>{
    return state.getCompareDataDownloadTray
  },
  getprojectUsers:state=>{
    return state.projectUsers
  },
  getupdatedProjectUser:state=>{
    return state.updatedProjectUser
  },

  getdeletedProjectUsers:state=>{
    return state.deletedProjectUsers
  },
  getselectedTray:state=>{
    return state.selectedTray
  }
};

// Mutations
const mutations = {
  setVirtualTrayType(state, type) {
    state.virtualTrayParam.type = type;
  },
  setAllVirtualTray(state, { data }) {
    state.filter= data.filter
    if (state.virtualTrayParam.pageNumber > 1) {
      state.boards = [...state.boards, ...data.boards];
    } else {
      state.boards = [...data.boards];
    }
  },
  setOrderHistoryData(state,  data ) {
    if (state.oderHistoryParam.pageNumber > 1) {
      state.orderHistory = [...state.orderHistory, ...data];
    } else {
      state.orderHistory = [...data];
    }
  },
  setVtTotalPage(state, { data }) {

          state.totalPage = Math.ceil(data.filter.totalCount / data.filter.pageSize);

  },
  setOhTotalPage(state, data) {
    state.orderHistoryTotalPage = Math.ceil(data.totalCount / state.orderHistorypageSize);
  },
  setselectedSortByOption(state, data) {
    state.selectedSortByOption = data;
    state.virtualTrayParam.sortBy =
      data === "CreatedAtAscTrue"
        ? "CreatedAt"
        : data === "TitleAscTrue"
        ? "Title"
        : data;
    state.virtualTrayParam.sortByAsc =
      data === "CreatedAtAscTrue" || data === "TitleAscTrue"  || state.orderBy  === "asc"? true : false;
  },
  setOrderby(state,  data) {
    state.orderBy = data;
  },
  setselectedTabName(state, data) {
    state.selectedTabName = data;
    state.virtualTrayParam.type = data;
      state.virtualTrayParam.searchTerm = ""
      state.virtualTrayParam.sortBy =  "UpdatedAt",
      state.virtualTrayParam.sortByAsc =  false

    state.boards = [];
  },
  setselectedSideNav(state, data) {
    state.selectedSideNav = data;
  },
  showModal(state, data) {
    state.isModalVisible = data;
  },
  setSearchInput(state, data) {
    state.searchtext = data;
    state.virtualTrayParam.searchTerm = data;
    state.boards = [];
  },
  setUserTrayIdApiResponse(state, { data }) {
    state.getTrayUserApiResponse = data;
    state.projectUsers = data.item2.boardUsers;
  },
  setCreateShareTrayResp(state, { data }) {
    state.createShareTray = data;

  state.updatedProjectUser = [
    ...state.updatedProjectUser,
    ...data.item2.boardUsers
  ];
  state.projectUsers = [...state.projectUsers,...data.item2.boardUsers]
  },

  setStopSharing(state, { data }) {
  state.deletedProjectUsers = state.projectUsers.filter(user=>user.role !== 3)
  state.updatedProjectUser = [];
  state.projectUsers = state.projectUsers.filter(user=>user.role == 3)

  },
  resetShareProject(state){
state.updatedProjectUser = [];
state.deletedProjectUsers = []
  },
  setUploadImageResp(state, { data }) {
    if(data.item2){
    state.uploadImageData = data.item2;
    state.trayState.coverImage = state.uploadImageData.id;
    state.trayState.coverPhoto = state.uploadImageData.link
    }
    else{
      state.uploadImageData = null;
    state.trayState.coverImage = '';
    state.trayState.coverPhoto = ''
    }
  },
  setEditTray(state, { data }) {
    state.boardDetails = data;
  },
  setShareTrayId(state, { data }) {
    state.shareTrayId = data.item2;
  },
  setRedirectToMyTray(state, redirectToMyTray) {
    state.redirectToMyTray = redirectToMyTray;
  },
  setShareTrayIdFromMyTrayPage(state, data) {
    state.shareTrayId = data;
  },
  setUserInfoEmail(state, data) {
    state.userInfoEmailId = data;
  },
  setRefreshTokenResponse(state, { data }) {
    state.refreshToken = data.accessToken;
  },
  updateLoader(state, data) {
    state.loader = data;
  },
  updateTrayDetails(state, data) {
    state.virtualTrayParam.type = state.selectedTabName;
    state.virtualTrayParam.sortBy = state.selectedSortByOption;
  },
  setSelectedTrayId(state, data) {
    state.selectedTrayId = data;
  },
  clearSelectedTrayId(state, isRemoveItems) {
    if (isRemoveItems == "remove") {
      state.selectedTrayId.forEach(element => {
        let trayIndex = state.boards.findIndex(e => e.id == element);
        if (trayIndex >= 0) {
          state.boards.splice(trayIndex, 1);
        }
      });
    }
    state.selectedTrayId = [];
  },
  setPageNumber(state, initialPage) {
    if (initialPage) {
      state.virtualTrayParam.pageNumber = 1;
      state.boards = [];
    } else {
      state.virtualTrayParam.pageNumber = state.virtualTrayParam.pageNumber + 1;
    }
  },
  setOrderHistPageNumber(state, initialPage) {
    if (initialPage) {
      state.oderHistoryParam.pageNumber = 1;
      state.orderHistory = [];
    } else {
      state.oderHistoryParam.pageNumber = state.oderHistoryParam.pageNumber + 1;
    }
  },
  setmodalArchiveMsg(state,data){
    state.archiveMsgString = data
  },
  setFileName(state,data){
    state.fileName = data
  },
  setFileUrl(state,data){
    state.fileUrl = data
  },
  setimageData(state,data){
    state.imageData = data
  },
  setimageCropData(state,data){
    state.imageCropData = data
  },
  setImagelement(state,data){
    state.imageCropped = data
  },
  setCoverImageCroppings(state,data){
    state.coverImageCroppings = data
  },
  setBlobUrl(state,data){
    state.blobURL = data
  },
  setTrayEditDetails(state,data){
    state.trayEditDetails = data
  },
  settrayEditId(state,data){
    state.trayEditId = data;
  },
  setSelectedTray(state,data){
    state.selectedTray = data;
  },
  setResourceString(state,data){
    state.resourceString = data
  },
  setTrayAlreadyExistResourceString(state,data){
    state.trayAlreadyExist = data
  },
  setArchiveResourceString(state,data){
    state.archiveResourceString = data
  },
  setSaveTrayForShare(state,data){
    state.saveTrayForShare = data
  },
  setstartOverOrCancel(state,data){
    state.IsstartOverOrCancel = data
  },
  setselectAnotherImage(state,data){
    state.selectAnotherImage = data
  },
  setfetchTrayDetails(state,data){
    state.getCompareData = data
  },
  setfetchTrayDetailsDownloadTray(state,data){
    state.getCompareDataDownloadTray = data
  },
  setisAdmin(state,data){
    state.isAdminMode = data
  },
  userDeleteFromRoleListHandler(state,userEmail){
    const userDataIndex = state.projectUsers.findIndex((user) => user.email === userEmail);
    state.deletedProjectUsers.push(state.projectUsers[userDataIndex]);
    state.projectUsers.splice(userDataIndex, 1);
  },
  userRoleChangeHandler(state,data){
    const userDataIndex =  state.projectUsers.findIndex((user) => user.email === data.emailFromUsersList);
    state.projectUsers[userDataIndex].role = data.newRole;
  },
  updateWatcher(state,userEmail){
    const userUpdatedAlreadyIndex = state.updatedProjectUser.findIndex((user) => user.email === userEmail);
    if (userUpdatedAlreadyIndex === -1) {
      const userDataIndex = state.projectUsers.findIndex((user)=>user.email === userEmail)
      state.updatedProjectUser.push(state.projectUsers[userDataIndex]);
    }
  },

  setCommonErrorMsg(state,data){
    state.errorMsg = data
  }


}


// Actions
const actions = {
  async createTray({ commit, dispatch, state }, {trayDetail, isCallFromMyProject = false}) {
    return await PatcraftApi.createTray(trayDetail)
      .then(res => {
        dispatch(
          "notifications/add",
          {
            type: "success",
            title: state.resourceString,
            description: ""
          },
          { root: true }
        );

        localStorage.removeItem('tray');
        commit("setShareTrayId", res);
        commit("setRedirectToMyTray",true)

        return true;
      })
      .catch(err => {
        const error = new Error(err);
        const statusCode = parseInt(error.message.split(" ").pop());
        if(statusCode == 409){
          if(!isCallFromMyProject){
            dispatch(
              "notifications/add",
              {
                type: "success",
                title: state.trayAlreadyExist,
                description: ""
              },
              { root: true }
            );
          }
          return 409;
        }else{
          commonMethods.handleCatch(dispatch, commit, error, state, true);
          return false;
        }
      });
  },
  async UpdateTray({ commit, dispatch, state }, trayDetail) {
    return await PatcraftApi.UpdateTray(trayDetail)
      .then(res => {
        dispatch(
          "notifications/add",
          {
            type: "success",
            title: state.resourceString,
            description: ""
          },
          { root: true }
        );

        localStorage.removeItem('tray');

        return true;
      })
      .catch(err => {
        const error = new Error(err);
        const statusCode = parseInt(error.message.split(" ").pop());
        if(statusCode == 409){
          dispatch(
            "notifications/add",
            {
              type: "success",
              title: state.trayAlreadyExist,
              description: ""
            },
            { root: true }
          );
        }else{
        commonMethods.handleCatch(dispatch, commit, error, state, true);
        }
        return false
      });
  },

   urlCopied({state, dispatch}){
    dispatch(
      "notifications/add",
      {
        type: "success",
        title: state.resourceString,
        description: ""
      },
      { root: true }
    );
  },

  async shareTray({ commit, dispatch, state }, shareDetails) {
    commit("updateLoader", true);
    await PatcraftApi.shareTray(shareDetails)
      .then(res => {
        dispatch(
          "notifications/add",
          {
            type: "success",
            title: state.resourceString,
            description: ""
          },
          { root: true }
        );
      })
      .catch(err => {
        const error = new Error(err);
        commonMethods.handleCatch(dispatch, commit, error, state, true);
      })
      .finally(() => {
        commit("updateLoader", false);
      });
  },

  async getNewTokenAction({ dispatch, commit, state }) {
    let newAadToken = null;
    let getAadCookie = this._vm.$cookies.get("Aad");
    if (getAadCookie) {
      let aadToken = JSON.parse(atob(getAadCookie));
      if (new Date() > new Date(aadToken.expirationDate)) {
        await PatcraftApi.getNewToken()
          .then(res => {
            newAadToken = res.data.accessToken;
          })
          .catch(err => {
            const error = new Error(err);
            commonMethods.handleCatch(dispatch, commit, error, state, false);
          });
      }
      newAadToken = aadToken.accessToken;
    }
    return newAadToken;
  },
  setSiteProjectName({state}, data){
    state.virtualTrayParam.siteProjectName = data;
  },
  async updateAllVirtualTray({ commit, state, dispatch }, siteProjectName = 'VirtualTray') {
    if (window.location.href.toLowerCase().includes("project") && state.virtualTrayParam?.type === "Brand") {
      state.virtualTrayParam.brandBoardType = "Published";
      state.virtualTrayParam.siteProjectName = "ProjectFeature";
    } else {
      state.virtualTrayParam.brandBoardType = "";
    }
    state.virtualTrayParam.siteProjectName = siteProjectName;
    commit("updateLoader", true);
    await PatcraftApi.getAllVirtualTray(state.virtualTrayParam)
      .then(res => {
        console.log(res)
        commit("setAllVirtualTray", res);
        commit("setVtTotalPage", res);
        dispatch("updateSelectedTray");
        commit("updateLoader", false);
      })
      .catch(err => {
        const error = new Error(err);
        commonMethods.handleCatch(dispatch, commit, error, state, true);
      })

  },
  async updateOrderHistoryData({ commit, state, dispatch },orderHistoryPayload){
    commit("updateLoader", true);
     commit("setOrderHistoryData", orderHistoryPayload);
       commit("setOhTotalPage", orderHistoryPayload);

  },
  async deleteVirtualTray({ commit, dispatch, state }, trayId) {
    //PassAadToken
    commit("updateLoader", true);
    await PatcraftApi.deleteVirtualTray(trayId)
      .then(res => {
        dispatch(
          "notifications/add",
          {
            type: "success",
            title: state.resourceString,
            description: ""
          },
          { root: true }
        );
        dispatch("updateSelectedTray", "remove");
      })
      .catch(err => {
        const error = new Error(err);
        commonMethods.handleCatch(dispatch, commit, error, state, true);
      })
      .finally(() => {
        commit("updateLoader", false);
      });
  },

  async archiveVirtualTray({ commit, dispatch, state }, trayId) {
    commit("updateLoader", true);
    await PatcraftApi.archivirtualTray(trayId)
      .then(res => {
        dispatch(
          "notifications/add",
          {
            type: "success",
            title: state.archiveMsgString === "Reactivate"? state.resourceString:state.archiveResourceString,
            description: ""
          },
          { root: true }
        );
        dispatch("updateSelectedTray", "remove");
      })
      .catch(err => {
        const error = new Error(err);
        commonMethods.handleCatch(dispatch, commit, error, state, true);
      })
      .finally(() => {
        commit("updateLoader", false);
      });
  },
  loadMoreData({ commit, dispatch, state }) {
    commit("setPageNumber");
    dispatch("updateAllVirtualTray", state.virtualTrayParam.siteProjectName);
  },
  loadMoreOrderHistoryData({ commit, dispatch, state }) {
    commit("setPageNumber");
    dispatch("updateAllVirtualTray", state.virtualTrayParam.siteProjectName);

    dispatch("updateOrderHistoryData");

  },
  async upadteSelectedSortby({ commit, dispatch, state }, selectedOption) {
    commit("setselectedSortByOption", selectedOption);
    commit("setPageNumber", true);
    dispatch("updateAllVirtualTray", state.virtualTrayParam.siteProjectName);
  },
  async upadteOrderby({ commit, dispatch }, orderBy) {
    commit("setOrderby", orderBy);
  },
  async updateTabName({ commit, dispatch, state }, tabName) {
    commit("setselectedTabName", tabName);
    commit("setPageNumber", true);
    dispatch("updateAllVirtualTray", state.virtualTrayParam.siteProjectName);
  },

  async updateSelectedSideNav({ commit, dispatch }, tabName) {
    commit("setselectedSideNav", tabName);

  },
  async updateModal({ commit }, bool) {
    commit("showModal", bool);
  },
  async updateSearchInput({ commit, dispatch, state }, searchInput) {
    commit("setSearchInput", searchInput);
    commit("setPageNumber", true);
    dispatch("updateAllVirtualTray", state.virtualTrayParam.siteProjectName);
  },
  async updateSelectedTrayId({ commit }, trayId) {
    commit("setSelectedTrayId", trayId);
  },
  async updateSelectedTray({ commit }, isRemoveItems) {
    commit("clearSelectedTrayId", isRemoveItems);
  },
  async updateShareTrayIfFromMyTrayPage({ commit }, trayId) {
    commit("setShareTrayIdFromMyTrayPage", trayId);
  },

  async modalArchiveMsg({commit},archiveMsg){
    commit("setmodalArchiveMsg", archiveMsg);
  },
  async selectedFileOnSaveModal({commit},fileName){
    commit("setFileName",fileName)
  },
  async selectedFileUrlOnSaveModal({commit},fileUrl){
    commit("setFileUrl",fileUrl)
  },
  async setImageData({commit},imageData) {
    commit ("setimageData",{ ...this.imageData, ...imageData })
  },
  async setImagelement({commit},imagelement){
    commit("setImagelement",imagelement)
  },
  async setImageCropData({commit},imageData){
    commit("setimageCropData",{ ...this.imageCropData, ...imageData });
  },
  async getUserTrayIdApiDetails({ commit, dispatch, state }, trayId) {
    let aadToken = await dispatch("getNewTokenAction");
    await PatcraftApi.getUserTrayId(trayId, aadToken)
      .then(res => {
        commit("setUserTrayIdApiResponse", res);
      })
      .catch(err => {
        const error = new Error(err);
        commonMethods.handleCatch(dispatch, commit, error, state, false);
      });
  },
  async createShareTrayApi({ commit, dispatch, state }, data) {
    let aadToken = await dispatch("getNewTokenAction");
    return await PatcraftApi.createShareTrayApi(data, aadToken)
      .then(res => {
        commit("setCreateShareTrayResp", res);
        return true
      })
      .catch(err => {
        const error = new Error(err);
        commonMethods.handleCatch(dispatch, commit, error, state, true);
        return false
      });
  },
  async userInfoDetails({ commit }, email) {
    commit("setUserInfoEmail", email);
  },

  async CoverImageCroppingsAction({commit,state},coverImageCroppings) {
    if(coverImageCroppings){
    commit("setCoverImageCroppings",coverImageCroppings)
    }
  },

  async virtualTrayEdit({ commit, dispatch, state }, trayId) {
    let aadToken = await dispatch("getNewTokenAction");
    await PatcraftApi.editTray(trayId, aadToken)
      .then(res => {
        commit("setCreateShareTrayResp", res);
      })
      .catch(err => {
        const error = new Error(err);
        commonMethods.handleCatch(dispatch, commit, error, state, true);
      });
  },
  async uploadImage({commit,dispatch,state},fileData){
    // let aadToken = await dispatch("getNewTokenAction");
      await PatcraftApi.uploadImage(fileData)
      .then(res => {
        commit("setUploadImageResp", res);
        // dispatch("setImageBlobs")
        dispatch("CoverImageCroppingsAction",coverImageCroppingsTransformer(state.imageData,state.trayEditId,state.imageCropData))
        dispatch(
          "notifications/add",
          {
            type: "success",
            title: state.resourceString,
            description: ""
          },
          { root: true }
        );
        dispatch("startOverOrCancel",false)
        dispatch("selectAnotherImage",true)

      })
      .catch(err => {
        const error = new Error(err);
        const statusCode = parseInt(error.message.split(" ").pop());
        if(statusCode == 401){
          dispatch('uploadImage',(state.trayEditId,state.fileName))
        }
        commonMethods.handleCatch(dispatch, commit, error, state, true);
      });

  },

  async updateImageResp({commit},uploadImageResp){
    commit("setUploadImageResp",uploadImageResp)
    },

  async updateImageBlobd({commit},blobUrl){
  commit("setBlobUrl",blobUrl)
  },

  async setImageBlobs({state}) {
      let cropper = new Cropper(state.imageCropped, {
        });

        cropper.getCroppedCanvas()?.toBlob((blob) => {
          if (blob) {
            const blobURL = URL.createObjectURL(blob);
          }
        });

  },
  async publishTrayApi({state,dispatch, commit},publishId){
    let aadToken = await dispatch("getNewTokenAction");
      await PatcraftApi.publishTray(publishId, aadToken)
      .then(res => {
       dispatch("updateAllVirtualTray", state.virtualTrayParam.siteProjectName);
       dispatch(
        "notifications/add",
        {
          type: "success",
          title: state.resourceString,
          description: ""
        },
        { root: true }
       )
      })
      .catch(err => {
        const error = new Error(err);
        commonMethods.handleCatch(dispatch, commit, error, state, true);
      });


  },
  async unpublishTrayApi({state,dispatch, commit},unpublishId){
    let aadToken = await dispatch("getNewTokenAction");
      await PatcraftApi.unpublishTray(unpublishId, aadToken)
      .then(res => {
       dispatch("updateAllVirtualTray", state.virtualTrayParam.siteProjectName);
       dispatch(
        "notifications/add",
        {
          type: "success",
          title: state.resourceString,
          description: ""
        },
        { root: true }
       )
      })
      .catch(err => {
        const error = new Error(err);
        commonMethods.handleCatch(dispatch, commit, error, state, true);
      })
  },
  async trayEditDetails({commit,state},traydetails) {
    commit("setTrayEditDetails",traydetails)
  },
  async UpdatetrayEditId({commit,state},id) {
    commit("settrayEditId",id)
  },
  async setSelectedTray({commit,state},trayType){
    commit("setSelectedTray",trayType)
  },
  async resourceString({commit},resourceStringData){
    commit("setResourceString",resourceStringData)
  },
  async trayAlreadyExistResourceString({commit},resourceStringData){
    commit("setTrayAlreadyExistResourceString",resourceStringData)
  },
  async archiveResourceString({commit},resourceStringData){
    commit("setArchiveResourceString",resourceStringData)
  },
  async saveTrayForShare({commit,dispatch},resourceStringData){
    commit("setSaveTrayForShare",resourceStringData)
    dispatch(
      "notifications/add",
      {
        type: "success",
        title: resourceStringData,
        description: ""
      },
      { root: true }
    );
  },
  async startOverOrCancel({commit,dispatch},isstartOverOrCancel){
    commit("setstartOverOrCancel",isstartOverOrCancel)
  },
  async selectAnotherImage({commit,dispatch},isSelectAnotherImage){
    commit("setselectAnotherImage",isSelectAnotherImage)

  },

  async fetchTrayDetails({ dispatch, commit, state }, styleNumber) {
    await PatcraftApi.compareFeature(styleNumber)
      .then(response => {
        commit("setfetchTrayDetails", response.data[0]);
        commit("setfetchTrayDetailsDownloadTray", response.data);
        return response;
      })
      .catch(err => {
        const error = new Error(err);
        commonMethods.handleCatch(dispatch, commit, error, state, false);
      });
  },
  async isAdminMode({commit},isAdmin){
    commit("setisAdmin",isAdmin)
  },

  async  updateWatcher({commit},userEmail){
    commit("updateWatcher",userEmail)

  },

  async userRoleChangeHandler({commit,dispatch},data) {
    await commit("userRoleChangeHandler",data)
    await dispatch("updateWatcher",data.emailFromUsersList)

  },

  userDeleteFromRoleListHandler({commit},userEmail){
    commit("userDeleteFromRoleListHandler",userEmail)
  },

  async saveShareProject({ commit, dispatch,state }, data){
    await PatcraftApi.SaveUsers(data)
      .then(res => {
        dispatch(
          "notifications/add",
          {
            type: "success",
            title: state.resourceString,
            description: ""
          },
          { root: true }
        );
      })
      .catch(err => {
        const error = new Error(err);
        commonMethods.handleCatch(dispatch, commit, error, state, true);
      });
  },

  updateStopSharing({commit}){
    commit("setStopSharing",{data:[]})
  },

  resetShareProject({commit}){
    commit('resetShareProject')

  },
  updateCommonErrorMsg({commit},data){
    commit("setCommonErrorMsg",data)
  },
  async duplicateSwatchErrMsg({commit,dispatch},resourceStringData){
    dispatch(
      "notifications/add",
      {
        type: "success",
        title: resourceStringData,
        description: ""
      },
      { root: true }
    );
  },
  setVirtualTrayType({ commit }, type) {
    commit("setVirtualTrayType", type);
  },

};



export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
